// extracted by mini-css-extract-plugin
module.exports = {"header":"ManageAdmins_header__37eAF"};